// allow selection of only one checkbox in a group
function checkboxGroups() {
  document.querySelectorAll('.checkbox-group')?.forEach(group => {
    const checkboxes = group.querySelectorAll('input[type=checkbox]')
    checkboxes?.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        checkboxes.forEach(thisCheckbox => {
          if (thisCheckbox !== checkbox) thisCheckbox.checked = false
        })
      })
    })
  })
}

function updateBirthstonePreviews() {
  const moonPickers = document.querySelectorAll('moon-phase-finder');
  const birthstonePickers = document.querySelectorAll('birthstone-picker');

  const indexOffset = moonPickers.length; // Adjust based on how many moons exist (0, 1, or 2)

  birthstonePickers.forEach(picker => {
    const rawIndex = parseInt(picker.dataset.index);
    const previewIndex = rawIndex + indexOffset;

    const selectedImg = picker.querySelector('.selected-image img');
    if (!selectedImg || isNaN(previewIndex)) {
      console.warn(`⚠️ Skipped picker with index ${rawIndex}`);
      return;
    }

    const previewImg = document.getElementById(`preview-img-moon-${previewIndex}`);
    if (previewImg) {
      previewImg.src = selectedImg.src;
    } else {
      console.warn(`❌ No moon image found for index ${previewIndex}`);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  checkboxGroups()
  updateBirthstonePreviews()

  const moonPickers = document.querySelectorAll('moon-phase-finder');
  const birthstonePickers = document.querySelectorAll('birthstone-picker');
  if (moonPickers.length >= 2 && birthstonePickers.length >= 2) {
    // Move birthstone 1 after moon 1
    moonPickers[0].after(birthstonePickers[0]);
    // Move birthstone 2 after moon 2
    moonPickers[1].after(birthstonePickers[1]);
  }
});

document.addEventListener('click', () => {
  setTimeout(updateBirthstonePreviews, 100);
});
